import FileSaver from 'file-saver';
import { objectHelper } from 'utils/objectHelper';

import {
    FullKeyPairApiEntity,
    KeyPair,
    KeyPairApiEntity,
} from './KeyPairsModule.types';

export function camelCaseApiItemData(
    item: KeyPairApiEntity & Partial<FullKeyPairApiEntity>,
): KeyPair {
    return objectHelper.camelCaseKeys(item) as any;
}

export function snakeKeysItemData(
    item: Partial<KeyPair>,
): Partial<FullKeyPairApiEntity> {
    return objectHelper.snakeCaseKeys(item);
}

export function savePrivateKey({
    keyName,
    privateKey,
}: {
    keyName: string;
    privateKey: string;
}) {
    const privateKeyBlob = new Blob([privateKey], {
        type: 'text/plain',
    });

    FileSaver.saveAs(privateKeyBlob, `${keyName}.pem`);
}
